module.exports = __webpack_public_path__ + "assets/img/21_1110_big.ac6edb44.jpg";